import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, switchMap, filter, take } from 'rxjs/operators';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { LoginService } from '../services/Login.service';
import { Router } from '@angular/router';

@Injectable()
export class RequestHandlerInterceptor implements HttpInterceptor {
  firstCheck = false;
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );
  constructor(
    private notification: NzNotificationService,
    private loginService: LoginService,
    private router: Router
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let authReq = request;
    const token = localStorage.getItem('token');
    if (token != null) {
      authReq = this.addToken(request, token);
    }

    return next.handle(authReq).pipe(
      catchError((error) => {
        if (typeof error.error == 'string') {
          this.notification.error('Error', error.error);
        } else if (error.error?.error?.message) {
          this.notification.error('Error', error.error?.error?.message);
        }
        if (error.status === 404) {
          this.notification.error('Error', 'Action not found');
        } else if (error.status === 406) {
          this.notLicensedError();
        } else if (error.status === 403) {
          this.notification.error(
            'Unauthorized action',
            'You are not authorized to make this action'
          );
        }
        if (error instanceof HttpErrorResponse && error.status === 401) {
          return this.handle401Error(authReq, next);
        }
        return throwError(() => error);
      })
    );
  }
  notLicensedError() {
    this.router.navigate(['/license']);
  }

  private addToken(request: HttpRequest<any>, token: string) {
    let newHeaders = request.headers;
    newHeaders = newHeaders.set('Authorization', 'Bearer ' + token);

    if (!newHeaders.has('Content-Type')) {
      if (request.body instanceof FormData) {
        // from data doesn't have content type
        // newHeaders = newHeaders.append('Content-Type', null);
      } else {
        newHeaders = newHeaders.append('Content-Type', 'application/json');
      }
    }

    return request.clone({
      headers: newHeaders,
    });
  }

  handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    
    if (!this.isRefreshing || this.refreshTokenSubject.value == null) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.loginService.refreshToken().pipe(
        switchMap((response: any) => {
          
          this.isRefreshing = false;
          localStorage.setItem('token', response.token);
          localStorage.setItem('refreshToken', response.refreshToken);
          this.refreshTokenSubject.next(response.token);
          return next.handle(this.addToken(request, response.token));
        }),
        catchError((error) => {
          
          this.loginService.loginStatus.next(false);
          localStorage.removeItem('token');
          localStorage.removeItem('refreshToken');
          this.router.navigate(['/auth/login']);
          throw new Error('unautherized');
        })
      );
    } else {
      if (this.refreshTokenSubject.value == null) {
        this.isRefreshing = false;
      }
      return this.refreshTokenSubject.pipe(
        filter((token) => token != null),
        take(1),
        switchMap((jwt) => {
          return next.handle(this.addToken(request, jwt));
        })
      );
    }
  }
}
